import { isRejectedWithValue,} from "@reduxjs/toolkit";
import {createStandaloneToast} from '@chakra-ui/react'
import isBaseQueryError from "@shared/helpers/isBaseQueryError";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";

const {toast} = createStandaloneToast()

const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
    if(isRejectedWithValue(action)){
        toast({
            title: 'Error de servicio',
            // @ts-ignore
            description: isBaseQueryError(action.payload) ? action.payload.message : action.payload.data.message,
            status: 'error',
            duration: 9000,
            isClosable: true,
          })
    }

    return next(action)
}

export default rtkQueryErrorLogger;
